<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-flip-vertical`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 25v-2c0-.51.388-.935.884-.993L5 22h38c.51 0 .935.388.993.884L44 23v2c0 .51-.388.935-.884.993L43 26H5c-.51 0-.935-.388-.993-.884L4 25zm3 6a1 1 0 011-1h33a1 1 0 011 1v10a2 2 0 01-2 2H9a2 2 0 01-2-2V31zM8 7a2 2 0 012-2h29a2 2 0 012 2v10a1 1 0 01-1 1h-2a1 1 0 01-1-.999V9H12v8a1 1 0 01-1 1H9a1 1 0 01-1-1V7z"/></svg>
</template>
<script>

export default {
  name: 'IconFlipVertical',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
